<div class="wheel-container">
  <!-- Outer glow ring with bulbs -->
  <div class="outer-ring">
    <div class="bulb" *ngFor="let b of bulbs; let i = index"
         [style.left.%]="getBulbX(b)"
         [style.top.%]="getBulbY(b)"
         [class.lit]="i % 2 === 0 ? bulbLit : !bulbLit">
    </div>
  </div>

  <!-- Pointer -->
  <div class="wheel-pointer">
    <svg width="44" height="56" viewBox="0 0 44 56">
      <defs>
        <linearGradient id="ptrGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#FF4444"/>
          <stop offset="100%" stop-color="#CC0000"/>
        </linearGradient>
        <filter id="ptrShadow">
          <feDropShadow dx="0" dy="3" stdDeviation="3" flood-opacity="0.5"/>
        </filter>
      </defs>
      <polygon points="22,56 2,8 42,8" fill="url(#ptrGrad)" filter="url(#ptrShadow)"/>
      <polygon points="22,48 8,12 36,12" fill="#FF6666" opacity="0.4"/>
    </svg>
  </div>

  <!-- Wheel -->
  <div class="wheel"
       [style.transform]="'rotate(' + currentRotation + 'deg)'"
       [class.spinning]="isSpinning">

    <!-- Gold inner border ring -->
    <div class="gold-ring"></div>

    <!-- Segments via SVG for precise pie slices -->
    <svg class="segments-svg" viewBox="0 0 400 400">
      <defs>
        <filter id="segShadow">
          <feDropShadow dx="0" dy="0" stdDeviation="1" flood-opacity="0.3"/>
        </filter>
      </defs>
      <g *ngFor="let student of students; let i = index">
        <path [attr.d]="getSegmentPath(i)"
              [attr.fill]="getSegmentFill(i)"
              stroke="rgba(255,215,0,0.4)" stroke-width="1.5"
              filter="url(#segShadow)"/>
      </g>
    </svg>

    <!-- Segment labels (on top of SVG) -->
    <div *ngFor="let student of students; let i = index"
         class="segment-label"
         [style.transform]="getLabelTransform(i)">
      <img [src]="getImageUrl(student)" class="seg-avatar"
           [style.width.px]="getAvatarSize()" [style.height.px]="getAvatarSize()" alt=""/>
      <span class="seg-name" [style.font-size.px]="getNameSize()">{{ getStudentLabel(student) }}</span>
    </div>

    <!-- Center hub -->
    <div class="wheel-center">
      <div class="center-shine"></div>
      <span class="center-text">{{ currLang === 'ar' ? 'أدر' : 'SPIN' }}</span>
    </div>
  </div>
</div>
